import React, {useEffect, useState} from 'react';
import CreateSDS from "./CreateSDS";
import {Col, Row} from "react-bootstrap";
import {useSelector} from "react-redux";
import axios from "axios";
import {Link} from "react-router-dom";

const Sds = () => {
    const userLogin = useSelector(state => state.userLogin)
    const {userInfo} = userLogin
    const [loading, setLoading] = useState(false);
    const [sds, setSDS] = useState([]);

    useEffect(()=>{
        const loadClients = async ()=> {
            setLoading(true);
            const response = await axios.get('https://homesafetysolutions.pythonanywhere.com/api/sds/', {
                // const response = await axios.get('http://127.0.0.1:8000/api/sds/', {
                headers: {
                    'Content-type': 'application/json',
                    Authorization: `Bearer ${userInfo.token}`
                }
            });
            setSDS(response.data);
            setLoading(false)
        }
        loadClients();
    }, []);

    return(
        <div className={"banner_heading"}>
            <h1>Safety Data Sheets (SDS)</h1>
            <br /><br />
            <Row>
                <Col>
                    <h2>Create SDS</h2>
                </Col>
                <Col>
                    <CreateSDS />
                </Col>
            </Row>
            <hr />
            <br />
            {
                loading
                ?
                    (
                        <h4>"Loading..."</h4>
                    )
                    :
                    (
                        <div>
                            <h3>All SDS'S:</h3>
                            {
                                sds?.map(item =>
                                    <div key={item.sds_name} style={{padding: '15px 0'}}>
                                            <Link
                                                className={'btn btn-outline-primary'}
                                                style={{marginBottom: "10px"}}
                                                to={`/sds/${item.id}/`}
                                            >
                                                {item.sds_name}
                                            </Link>
                                    </div>
                                )}
                        </div>
                    )
            }

        </div>
    )
};

export default Sds;
